import Link from 'next/link';
import { getSortedPostsData } from '../../lib/posts';
import { format } from 'date-fns';
import Image from 'next/image';

export async function getStaticProps() {
  const allPostsData = getSortedPostsData();
  return { props: { allPostsData } };
}

export default function Blog({ allPostsData }) {
  return (
    <>
    {/*<div className="max-w-3xl mx-auto p-4">*/}
<div className="bg-white text-black">
 {/* Banner Section */}
      <div className="relative w-full h-[400px]">
        {/* Background Image */}
        <Image
          src="/images/cargo1.jpg" // Ensure the image is inside the 'public/images/' folder
          alt="Maritime Banner"
          fill
          className="object-cover"
          quality={90}
        />

        {/* Overlay for better text visibility */}
        <div className="absolute inset-0 bg-black/50"></div>

        {/* Title Text */}
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-6">
          <h1 className="text-5xl font-bold">Le Blog</h1>
          {/* <p className="mt-4 text-lg">
          Naviguer vers l&apos;avenir du transport maritime avec précision et fiabilité.
          </p> */}
        </div>
      </div>

 <div className="mt-20 max-w-7xl mx-auto w-[90%]">
    {/*  <h1 className="text-3xl font-bold mb-6">Blog</h1> */}
      <ul className="space-y-6">
        {allPostsData.map(({ id, date, title, excerpt }) => (
          <li key={id}>
            <Link href={`/blog/${id}`}>
              <h2 className="text-xl font-semibold hover:underline">{title}</h2>
            </Link>
            <p className="text-gray-600 text-sm">{format(new Date(date), 'MMMM d, yyyy')}</p>
            <p className="text-gray-800">{excerpt}</p>
          </li>
        ))}
      </ul>
</div>
    
    </div>
    </>
  );
}
